import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmar-accion',
  templateUrl: './confirmar-accion.component.html',
  styleUrls: ['./confirmar-accion.component.scss']
})
export class ConfirmarAccionComponent implements OnInit {

  @Input() color: 'primary' | 'accent' | 'warn' = null;
  @Input() tipoBtn: 'stroked' | 'flat' | 'icon' = null;
  @Input() txtBtnConfirmar : 'Eliminar' | 'Confirmar' = null;
  @Input() txtBtnRechazar = 'Cancelar';
  @Input() clase = '';
  @Input() icono = 'menu';
  @Input() bloquear: boolean = false;
  @Output() confirmar = new EventEmitter<boolean>();
  @Output() rechazar = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }


}
